import { AlpineComponent } from 'alpinejs';

type ServiceLinksListData = {
  toggleItem: (event: Event) => void,
  getAnchor: () => string | null,
}

export default ():AlpineComponent<ServiceLinksListData> => ({
  init() {
    const anchor = this.getAnchor();
    if (anchor) {
      const el = document.getElementById(anchor) as HTMLElement;
      if (el) {
        el.classList.add('toggled');
        // scroll on element
        const y = el.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  },

  getAnchor() {
    return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
  },

  toggleItem(event: Event) {
    const eTarget = event.target as HTMLElement;
    if (eTarget) {
      const article = eTarget.closest('article.article--link-group');
      if (article) {
        if (article.classList.contains('toggled')) {
          article.classList.remove('toggled');
        } else {
          article.classList.add('toggled');
        }
      }
    }
  },
});
